import React from "react"

interface Replacements {
  [key: string]: React.ReactNode
}

/**
 * Matches placeholders in a translation string.
 */
const OUTER_REGEX = /((?:\{\{|%\{)[^}]+(?:\}\}|%\}))/

/**
 * Matches the key from the translation placeholder.
 */
const INNER_REGEX = /(?:\{\{|%\{)([^}]+)(?:\}\}|%\})/

/**
 * Replaces placeholders in a translation string with values from a replacements object.
 * @param translation The translation string with placeholders.
 * @param replacements An object containing replacements for the placeholders.
 * @returns An array of strings and React components to be rendered.
 */
export function replacePlaceholdersWithComponents(translation: string, replacements: Replacements): React.ReactNode[] {
  // Split the translation string by placeholders.
  const parts = translation.split(OUTER_REGEX).filter((part) => part)

  // Replace placeholders with their corresponding values from the replacements object.
  return parts.map((part, index) => {
    const match = part.match(INNER_REGEX)

    if (match) {
      const replacementKey = match[1]
      return <React.Fragment key={index}>{replacements[replacementKey] || null}</React.Fragment>
    }
    return <React.Fragment key={index}>{part}</React.Fragment>
  })
}
